// Configuration des rôles et permissions de l'application

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  MANAGER: 'manager',
  ACCOUNTING: 'accounting',
  AGENT: 'agent',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [
    'company:manage',
    'user:manage',
  ],
  [ROLES.MANAGER]: [
    'dashboard:view',
    'ticket:view',
    'ticket:create',
    'ticket:validate',
    'ticket:edit',
    'report:view',
    'report:export',
    'settings:manage',
  ],
  [ROLES.ACCOUNTING]: [
    'ticket:view',
    'ticket:export',
    'report:view',
    'report:export',
  ],
  [ROLES.AGENT]: [
    'ticket:view',
    'ticket:create',
    'ticket:view:own',
    'weighing:create',
  ],
} as const;

export type Permission = typeof ROLE_PERMISSIONS[keyof typeof ROLE_PERMISSIONS][number];

export function hasPermission(role: Role, permission: string): boolean {
  return (ROLE_PERMISSIONS[role] as readonly string[]).includes(permission);
}

export interface UserWithRole {
  id: string;
  email: string;
  role: Role;
  companyId: string | null;
}
